<template>
  <div class="downhis bg-white" @click="hidedraft()">
    <headerCom>
      <div slot="act" class="down-tips-view" v-if="hasRunning">
        <div class="down-tips">
          <el-link type="success" @click="openSub"><span class="black-font">打包中……</span>提醒我<span class="black-font">（打包完成后在对应的下载记录中下载，有效期24小时，到期自动清理）</span></el-link>
        </div>
        <div class="down-tips-message" @click="getnewlist">
          <i class="el-icon-time"></i>
        </div>
      </div>
    </headerCom>
    <div class="down-content"  style="position: relative;">
      <draftcover ref="collectcover" v-on:getdraftid="getdraftid"></draftcover>
      <div class="down-help flex align-center justify-between text-df" v-if="draftinfo">
        <trafficPopover :draftinfo="draftinfo" ref="trafficPopover"></trafficPopover>
        <div><a href="https://support.qq.com/products/57964/faqs/108280" target="_blank">打包下载常见问题</a></div>
        <div class="flex align-center justify-center text-white margin-left" @click="getnewlist"
          style="width: 100px;height: 21px;background: linear-gradient(0deg,#fe6e5b, #ff843a 96%);border-radius: 2px;">
          刷新打包进度
        </div>
      </div>
      <el-tabs v-model="recordType" @tab-click="recordTypeClick">
        <el-tab-pane label="打包记录" name="1"></el-tab-pane>
        <el-tab-pane label="下载记录" name="2"></el-tab-pane>
      </el-tabs>
      <div style="width: 100%;padding-right:15px;box-sizing: border-box;">
        <div class="table-total flex-lr bg-light-gray black-font font-size12">
          <div class="table-total flex-lm bg-light-gray black-font font-size12">
            <div class="flex-lm" style="margin-right: 35px;">
              <div class="font-size12 gray-font" style="margin-right: 10px;">时间选择</div>
              <template>
                <el-select v-model="modeltime" placeholder="请选择" @change="selecttime($event)" style="width: 150px;">
                  <el-option size="mini" v-for="item in timeoption" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div class="block" :style="{ marginLeft: 10 + 'px', display: modeltime == 100 ? 'flex' : 'none' }">
                  <el-date-picker @change="selectdate" format="yyyy-MM-dd HH:mm" v-model="value1" type="datetimerange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </div>
              </template>
            </div>
            <div class="flex-lm" v-if="recordType == 2">
              <div class="font-size12 gray-font" style="margin-right: 10px;">选择类型</div>
              <template>
                <el-select v-model="modelvalue" placeholder="请选择" @change="selectorder($event)" style="width: 150px;">
                  <el-option size="medium" v-for="item in options" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </div>
          </div>

        </div>
        <el-scrollbar>
          <el-table border v-if="draftinfo.activityAuth" :data="tableData" ref="multipleTable" highlight-current-row
            @select-all="handleTableSelect" @select="handleTableSelect" header-row-class-name="header-row-class-name"
            :height="tableHeight">
            <el-table-column type="selection" align="center" width="55">
            </el-table-column>
            <el-table-column prop="downloadTime" width="100" label="下载时间">
            </el-table-column>
            <el-table-column prop="fileName" label="文件名称">
            </el-table-column>
            <el-table-column align="center" label="文件大小" width="80">
              <template slot-scope="scope">
                {{ (scope.row.fileSize / 1024 / 1024).toFixed(2) }}M
              </template>
            </el-table-column>
            <el-table-column prop="activityName" label="所属活动">
            </el-table-column>
            <el-table-column prop="operator" width="100" label="操作人">
            </el-table-column>
            <el-table-column width="80" align="center" label="人员类型">
              <template slot-scope="scope">
                {{ ['发起人', '管理员', '协作人', '其他'][scope.row.userType] }}
              </template>
            </el-table-column>
            <el-table-column prop="mobile" width="120" label="联系电话">
            </el-table-column>
            <el-table-column width="80" align="center" label="下载终端">
              <template slot-scope="scope">
                {{ ['', 'PC端', '小程序'][scope.row.downloadTerminal] }}
              </template>
            </el-table-column>
            <el-table-column width="80" align="center" label="下载类型">
              <template slot-scope="scope">
                {{ ['', '批量下载', '打包下载', '下载'][scope.row.downloadType] }}
              </template>
            </el-table-column>
            <el-table-column width="80" align="center" label="状态">
              <template slot-scope="scope">
                <span v-if="recordType == 2">已完成</span>
                <span v-else="" :class="['', 'text-orange', 'text-green', '打包失败', '已失效'][scope.row.status]">{{ ['',
                  '正在打包', '打包完成', '打包失败', '已失效'][scope.row.status] }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="80" v-if="recordType == 1">
              <template slot-scope="scope">
                <div @click="getnewlist"
                  style="width: 60px;height: 21px;background: linear-gradient(0deg,#fe6e5b, #ff843a 96%);border-radius: 2px;"
                  class="text-sm text-white" v-if="scope.row.status == 1">刷新进度</div>
                <template v-if="(scope.row.downloadUrl && scope.row.status == 2)">
                  <downx :item="scope.row" :draftinfo="draftinfo" @event="getdetail" :identityType="identityType">
                  </downx>
                </template>

                <div type="info" size="mini" class="text-sm text-white"
                  style="width: 60px;height: 21px;background: #999999;border-radius: 2px;" v-if="scope.row.status == 4">
                  已过期</div>
                <!--
              <el-dropdown @command="optCommand">
                <span class="el-dropdown-link">
                  <i class="el-icon-view"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{scope:scope,act:'copy'}" v-if="scope.row.downloadUrl">复制下载链接</el-dropdown-item>
                  <el-dropdown-item :command="{scope:scope,act:'tips'}" v-if="scope.row.status==1">提醒我</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              -->
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="备注" width="100" v-if="recordType == 1">
              <template slot-scope="scope">
                <template v-if="scope.row.status == 1">
                  <div class="text-orange">预计10分钟左右打包完成</div>
                </template>
                <template v-if="scope.row.status == 2">
                  <div class="text-df">点击下载到电脑</div>
                </template>
                <template v-if="scope.row.status == 3">
                  <el-popover placement="bottom" width="400" trigger="hover">
                    <div class="font-14">
                      <div class="margin-bottom">建议解决办法： <br>1、使用批量下载，每次可选择200条（切换为每页展示200条）
                        <br>2、指定文件命名时，不要选择含特殊字符的内容。
                      </div>
                      <a href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B"
                        target="_blank" class="text-blue">联系客服 →</a>

                    </div>
                    <div slot="reference" class="text-red">解决办法</div>
                  </el-popover>
                </template>
                <template v-if="scope.row.status == 4">
                  <el-popover placement="bottom" width="400" trigger="hover">
                    <div class="font-14">
                      <div class="margin-bottom">1.打包下载的文件，会保存10个小时，超过10小时会自动过期，过期之后需要重新打包下载； <br>
                        2.已过期的文件，所消耗的下载额度，不返回；</div>
                      <a href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B"
                        target="_blank" class="text-blue">联系客服 →</a>

                    </div>
                    <div slot="reference" class="text-blue">查看帮助</div>
                  </el-popover>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
        <div class="page-down" v-if="total > 20">
          <el-pagination background :page-size=offset layout="prev, pager, next" :total="total" :current-page="page"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
    <el-dialog
            title="消息通知" class="fotoo"
            :visible.sync="dialogVisibleDownhis"
            width="75%" append-to-body
            :before-close="handleClose">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="公众号" name="wechat">
            <div class="block" style="text-align: center; ">
              <div class="font-size22 green-font" style="margin: 20px 0;">打包中……请耐心等待 <br/>你可以关注公众号接收结果消息</div>
              <el-image src="https://assets.pfotoo.com/images/wechat.qrcode.jpg" class="el-image-qrcode">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <div class="font-size18" style="margin-top: 20px;">微信扫码关注公众号</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="小程序" name="wxlite">
            <div class="block" style="text-align: center;">
              <el-image :src="codeurl">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <div class="font-size18" style="margin-top: 20px;">微信扫一扫，订阅通知</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import headerCom from '../header.vue'
  import draftcover from '../draftcover.vue'
  import App from '../../util/comfun'
  import ElLink from "../../../node_modules/element-ui/packages/link/src/main.vue";
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
  import downx from '../dialog/downx.vue'
  import trafficPopover from '../card/traffic-popover.vue'
  export default {
    name: 'download',
    data () {
      return {
        minHeight:window.innerHeight-82,
        tableHeight:window.innerHeight-225,
        tableData: [],
        draftlist:[],
        id:'',
        draftinfo:{},
        allselect:false,
        workidstr:'',
        workidarr:[],
        imgidstr:'',
        imgidarr:[],
        offset:20,
        minwidth:window.innerWidth-285,
        openid:JSON.parse(localStorage.getItem('userinfo')).openid,
        pdfurl:'',
        numPages:1,
        page:1,
        pdfhidden:true,
        total:0,
        unitlist:[],
        unit:'',
        options:[
          {
            label:'全部类型',
            value:0
          },
          {
            label:'批量下载',
            value:1
          },
          {
            label:'打包下载',
            value:2
          }
        ],
        timeoption:[
          {
              label:'全部时间',
              value:1
          },
          {
              label:'最近7天',
              value:7
          },
          {
              label:'最近30天',
              value:30
          },
          {
              label:'自定义',
              value:100
          }
        ],
        modelvalue:0,
        modeltime:1,
        value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
        alllist:[],
        searchval:'',
        inputfocus:false,
        total:0,
        obj:{
          type:'new'
        },

        dialogVisibleDownhis: false,
        activeName: 'wechat',
        codeurl:'',
        hasRunning:false,
        identityType:-1,//identityType 0创建，1管理，2协作
        VERSIONS:{},
        recordType: "1",//1打包记录 2下载记录
      }
    },
    components:{
      ElButton,
      ElLink,
      headerCom,
      draftcover,
      downx,
      trafficPopover,
    },
    methods:{
      MG:App.MG,
      changefoucusval(){
        this.inputfocus=!this.inputfocus;
        console.log('ttttt',this.inputfocus);
        if(!this.inputfocus && this.searchval==''){
          this.obj.type='new';
          this.page=1;
          this.getnewlist();
        }
      },
      recordTypeClick(val) {
        //this.recordType=val;
        this.page = 1;
        this.total = 0;
        this.getnewlist();
      },
      selectorder(val){
        console.log('selectorder',val)
        this.modelvalue=val;
        this.page=1;
        this.total=0;
        this.selectorderObj={type:val}
        this.getnewlist();
      },
      selecttime(val){
        console.log('selecttime',val);
        if(val==100){
          this.getvalue();
        }
        this.modeltime=val;
          this.page=1;
          this.workidarr=[];
          this.workidstr='';
          this.imgidarr=[];
          this.imgidstr='';
          this.allselect=false;
          this.total=0
        this.getnewlist();
      },
      selectdate(val){
        console.log(val)
        this.value1=val;
        this.page=1;
        this.workidarr=[];
        this.workidstr='';
        this.imgidarr=[];
        this.imgidstr='';
        this.allselect=false;
        this.total=0
        this.getnewlist();
      },
      getNumPages(url) {
        var loadingTask = pdf.createLoadingTask(url);
        console.log(loadingTask)
      	loadingTask.promise.then(pdf => {
          console.log('rccc',pdf,pdf.numPages)
      		this.numPages = pdf.numPages
      	}).catch((err) => {
      			console.error('pdf加载失败')
      	})
      },
      closepdf(){
        this.pdfhidden=true;
      },
      getsign(){
         return this.$getsign();
      },
      changedate(timestamp){
              var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
              var Y= date.getFullYear();
              var M =date.getMonth()+1;
              var D =date.getDate();
              var h = date.getHours();
              var m = date.getMinutes();
              var s = date.getSeconds();
              var w=date.getDay();
              return {year:Y,month:M,day:D,hour:h,minute:m,second:s,week:w};
      },
      async getvalue(){
        let sdate=new Date(Date.parse(new Date())-30*24*60*60*1000);
        this.value1=[sdate,new Date()];
      },
      getdetail(){
        this.queryUserIdentityType()
        this.getnewlist()
        App.Contribution.GetContributionById({id:this.id}).then(json=>{
          if(json.code==200){
            json.data.removead=json.data.activityAuth.isAdvertisement
            json.data.id=json.data.activityId
            json.data.name=json.data.activityName
            json.data.introduce=json.data.description
            json.data.images=json.data.activityCovers[0].url
            json.data.long_term=json.data.isLongTerm
            json.data.ispublic=json.data.visibleType//投稿可见类型 0：都可见 1：仅组织者可见
            json.data.iscomment=json.data.isComment//投稿作品评论（是否支持评论 1 是 0 否）
            json.data.type=App.metaKey(json.data.activityType,App.metaTypeHD)
            //附件
            json.data.is_enclosure=json.data.activityAuth.isAnnex
            json.data.enclosure_desc=json.data.activityAuth.enclosureTips
            //作品信息
            json.data.open_worksign=json.data.activityAuth.isAuthorName
            json.data.open_workdesc=json.data.activityAuth.isSubmissionDesp
            json.data.open_workname=json.data.activityAuth.isSubmissionName
            json.data.text=json.data.activityAuth.submissionTips
            //联系方式
            json.data.contacts_text=json.data.activityAuth.contactTips
            json.data.open_mail=json.data.activityAuth.isEmail
            json.data.open_phone=json.data.activityAuth.isMobile
            json.data.open_qq=json.data.activityAuth.isQq||0
            json.data.open_wechat=json.data.activityAuth.isWechat

            json.data.status=json.data.activityStatus==1?0:1
            //投稿要求
            json.data.other=json.data.activityAuth.submissionRequire||''
            //theme!='不限题材
            json.data.theme='不限题材'
            if(json.data.tagList.length>0){
              let theme=[];
              json.data.tagList.forEach(t=>{
                theme.push(t.name)
              })
              json.data.theme=theme.join(',')
            }
            //time
            json.data.stime=json.data.startTime
            json.data.etime=json.data.endTime
            json.data.close_time=json.data.deadlinesTime||''

            json.data.residualDownloadTraffic=0
            this.draftinfo=json.data
            this.getTrafficUser()
            //this.total=json.data.worksCount
            if(json.data.theme!='不限题材'){
              let arr=json.data.theme.split(',');
              let themelist=[];
              for(let i=0;i<arr.length;i++){
                themelist.push({
                  name:arr[i],
                  isactive:false,
                })
              }
              this.unitlist=themelist;
            }else{
              this.unitlist=[];
            }
            this.VERSIONS=wxlite.VERSIONS
          }
        })
      },
      getTrafficUser(){
        App.demand('/user/info','GET',{
          userId:this.draftinfo.createBy,
        }).then(res=>{
          this.draftinfo.residualDownloadTraffic=res.data.residualDownloadTraffic/1
          this.draftinfo.resetRightsDay=res.data.resetRightsDay
        })
      },
      handleTableSelect(selected){
        console.log('handleTableSelect',selected)
        this.selected=selected
        let workidarr=[];
        selected.forEach((v,i)=>{
          if(v.id){
            workidarr.push(v.id);
          }
        })
        this.workidarr=workidarr;
        this.workidstr=workidarr.toString();
        //this.currentRow = val;
      },
      hidedraft(){
        this.$refs.collectcover.closedraft();
      },
      handleCurrentChange(val){
        this.page=val;
        this.getnewlist();
      },
      async getdraftid(obj){
        this.id=obj.id;
        this.allselect=false;
        this.hidedraft();
        this.getdetail();

        let param=JSON.stringify({
          gotopath: '/person/pages/subscribe',
          message: '打包完成后提醒我',
          activityId:this.id,
          subscribeType:6,
        })
        let res = await App.demand('/activity/wechatapplet/saveParam', 'GET', {
          param: param,
        });
        this.codeurl=await App.System.Qrcode({
          autoColor: false,
          inHyaline: false,
          lineColor: '0,0,0',
          page: 'pages/enter/enter',
          scene: res.data,
          width: 430,
          appId:'wxe15e90f50a8379b7',
        },'URL')
      },
      //获得tagId
      getTagId(params) {
        console.info('getTagId', this.unit, this.draftinfo)
        if (this.unit && this.draftinfo.tagList) {
          this.draftinfo.tagList.some(t => {
            if (t.name == this.unit) {
              params.tagId = t.id
              return true
            }
          })
        }
        return params
      },
      getnewlist(){

        let paramdata={
         id:this.id,
         openid:this.openid,
         page:this.page,
         size:20,
         order:'asc',
        }
        if(this.modeltime!=1){
          let stime,etime;
          if(this.modeltime!=100){
            etime=Math.floor(Date.parse(new Date)/1000);
            stime=etime-this.modeltime*24*60*60;
          }else{
            stime=Math.floor(Date.parse(this.value1[0])/1000);
            etime=Math.floor(Date.parse(this.value1[1])/1000);
          }
          paramdata.cdate=stime+'-'+etime;
        }
        console.log('App.Submission.List',paramdata)
        let params = {
          "activityId": paramdata.id,
          "pageIndex": paramdata.page,
          "pageSize": paramdata.size,
          recordType: this.recordType,
        }
        if(this.selectorderObj && this.selectorderObj.type>0){
          params.downloadType=this.selectorderObj.type
        }
        if(paramdata.cdate){
          let cdate=paramdata.cdate.split('-')
          params.startTime=App.unixtoTime(cdate[0],"YYYY-MM-DD HH:II:SS")
          params.endTime=App.unixtoTime(cdate[1],"YYYY-MM-DD HH:II:SS")
        }
        params=this.getTagId(params)
        this.params=this.getTagId(params)
        this.tableData=[]
        this.total=0
        let loading=this.$loading({text:'loading...',target: '.down-content',})
        App.demand('/download/record/queryList','POST',params).then(json=>{
          setTimeout(()=>{loading.close();},0)
          if(json.code==200) {
            this.hasRunning=false
            json.data.recordList.forEach(r=>{
              r.downloadTime=App.unixtoTime(r.downloadTime,'YYYY-MM-DD HH:II:SS')
              if(r.status == 1){
                this.hasRunning=true
              }
            })
            this.tableData = json.data.recordList;
            this.total=json.data.total;
            if(this.$route.query.hasTips==1){
              this.$route.query.hasTips=0
              this.openSub()
              this.$refs.multipleTable.setCurrentRow(this.tableData[0]);
            }
          }else{
            this.imgCount=0
            this.worksCount=0
            this.browse=0
            this.likenum=0
            this.commentCount=0
            this.tableData=[];
            this.allselect=false;
            this.total=0;
            this.$message({
              showClose: true,
              message: json.message
            });

          }
        })
      },
      optCommand(command){
        console.log('deleteSub',command)
        let row=command.scope.row
        if(command.act=='tips'){
          this.openSub();
        }else{
          let createInput = document.createElement("input");
          createInput.value = row.downloadUrl;
          document.body.appendChild(createInput);
          createInput.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
          createInput.style.display = "none";
          this.$message({ message: "复制成功", type: "success" });
        }
      },
      openSub(){
        this.dialogVisibleDownhis=true;
      },
      handleClose(done) {
        done();
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      queryUserIdentityType(){
        App.demand('/activity/queryUserIdentity','GET',{activityId:this.id}).then(res=>{
          this.identityType=res.data.identityType
        })
      },
    },
    mounted(){
      this.getvalue();
    },

  }
</script>

<style scoped>
  .down-content {
  widdiv: 100%;
  position: relative;
  padding: 0;
}

.table-header {
  background: #FAFAFA;
}

.tr {
  height: 40px;
  line-height: 1.4;
  overflow: hidden;
}

.td {
  width: 60px;
  min-height: 40px;
  text-align: center;
  padding: 10px 5px;
  box-sizing: border-box;
  border-right: 1px solid #E0E0E0;
}

.bg-light-gray {
  background: #EEF2F2;
}

.table-total {
  width: 100%;
  height: 50px;
  padding: 0 10px;
  box-sizing: border-box;
}

.draft-total-data>div {
  margin-left: 20px;
  color: #999;
}

.draft-total-data>div:first-child {
  margin-left: 10px;
}

.draft-total-data .font-size14 {
  color: #353535;
}

.down-content {
  width: 100%;
  padding-left: 15px;
  box-sizing: border-box;
}

/* .draft-title{
    height: 50px;
    line-height: 50px;
    margin-right: 10px;
  } */
.table {
  width: 100%;
  border-top: 1px solid #E0E0E0;
  box-sizing: border-box;
  min-height: 540px;
  border-collapse: collapse;
}

.td:first-child {
  border-left: 1px solid #E0E0E0;
}

.checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  display: inline-block;
}

.page-down {
  padding: 5px 0;
  margin-left: -10px;
}

.work-img {
  width: 20px;
  height: 20px;
  display: inline-block;
}

.td a {}

.td a:hover {
  color: #27C4A2;
}

.pdf-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, .8);
}

.pdf-cover {
  width: 800px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  z-index: 10000;
  overflow: scroll;
  box-sizing: border-box;
}

.detail-unit-list {
  padding-top: 18px;
}

.detail-unit-single {
  margin-right: 30px;
  margin-bottom: 10px;
  line-height: 20px;
  padding: 5px 0;
  cursor: pointer;
  font-weight: 500;
}

.unit-green-font {
  border-bottom: 1px solid #3dc4a7;
}

.el-icon-arrow-up:before {
  content: "\E6E1";
  position: relative;
  top: -6px;
}

.down-content .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

.el-date-editor--datetimerange.el-input__inner {
  width: 356px;
}

.el-date-editor .el-icon-time {
  line-height: 22px;
}

.el-date-editor .el-range-separator {
  line-height: 22px;
}

.search {
  height: 36px;
  border-radius: 5px;
  background: #F2F2F3;
  margin-right: 20px;
}

.search-input {
  width: 100px;
  height: 100%;
  outline: none;
  transition: width ease .3s;
  background: transparent;
  padding: 0 5px;
  border: 0;
  box-sizing: border-box;
  line-height: 36px;
  font-size: 14px;
  margin-right: 5px;
}

.search-button {
  padding: 0 10px;
  height: 100%;
}

.search-button img {
  width: 15px;
  height: 16px;
}

.header-row-class-name .cell {
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Light;
  font-weight: 300;
  color: #999999;
  line-height: 17px;
}

.down-tips-view {
  position: relative;
  font-size: 14px;
  border-radius: 10px 10px 0 10px;
  overflow: hidden;
  width: 630px;
  height: 40px;
  margin-left: 80px;
}

.down-tips {
  width: 630px;
  height: 40px;
  background: #facebe;
  border-radius: 0 28px 0px 10px;
  position: absolute;
  left: 0px;
  top: 0px;
  content: "";
  color: #FE7157;
  font-size: 14px;
  line-height: 40px;
  text-indent: 25px;
}

.down-tips::after {
  width: 42px;
  height: 38px;
  position: absolute;
  left: 0;
  top: 0px;
  content: "";
  color: #fefefe;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  box-sizing: border-box;
  border-top: 40px solid #FE6E5B;
  border-right: 10px solid transparent;
}

.down-tips-message {
  width: 42px;
  height: 38px;
  position: absolute;
  left: 8px;
  top: 0px;
  content: "";
  color: #fefefe;
  font-size: 20px;
  line-height: 40px;
}

.el-image-qrcode {
  width: 400px;
  height: 400px;
}

.down-help {
  position: absolute;
  top: 0px;
  right: 10px;
  z-index: 20;
  height: 50px;
  line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/list/downhis.vue